<template>
    <div class="tab-internship">
        <div v-loading="loading">
            <Folder
                v-if="completed === 'true' || getMyInternship.length"
                :isFoldedDefault="hasActiveProjects"
                actions
                class="internship-folder"
                title="Стажировки"
                @active="completed = 'false'"
                @finished="completed = 'true'"
            >
                <div class="internship">
                    <InternshipItem v-for="item of getMyInternship" :key="item.id" :value="item" />
                </div>
            </Folder>
            <EmptyTabsCard
                v-else
                :emptyImgLink="emptyImgLink"
                cardTitle="Стажировки"
                toFullRouter="/internships/"
                emptyText="Еще нет стажировок"
            />
        </div>
    </div>
</template>

<script>
import InternshipItem from '@/components/account/tabs/tab-more/components/InternshipItem.vue';
import { mapActions, mapGetters } from 'vuex';
import Folder from '@/components/UI/Folder.vue';
import EmptyTabsCard from '@/components/UI/EmptyTabsCard.vue';

const getters = ['getMyInternship', 'getTotal'];
const actions = ['loadMyInternship'];
const dataActions = ['loadRegistryItems'];
export default {
    name: 'TabInsternship',
    components: {
        EmptyTabsCard,
        Folder,
        InternshipItem,
    },
    data: () => {
        return {
            loading: false,
            completed: 'false',
            tabIndex: 0,
        };
    },
    watch: {
        async completed() {
            this.loading = true;
            await this.loadMyInternship({
                completed: this.completed,
            });
            this.loading = false;
        },
    },
    computed: {
        ...mapGetters('internship', getters),
        hasActiveProjects() {
            return !this.getMyInternship.length > 0;
        },
        emptyImgLink() {
            return require(`@/assets/images/oops-rhino-draws.svg`);
        },
    },
    methods: {
        ...mapActions('internship', actions),
        ...mapActions('data', dataActions),
    },
    async created() {
        this.loading = true;
        await Promise.all([
            this.loadMyInternship({
                completed: this.completed,
            }),
            this.loadRegistryItems({ type: 'stage_history' }),
        ]);
        this.loading = false;
    },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/rem';
@import '~@/styles/mrem';

.tab-internship {
    .internship-folder {
        border-radius: rem(10) !important;
        font-family: Montserrat, sans-serif;
        :deep(header) {
            .title {
                font-weight: 700;
                font-size: mrem(22);
                @include on-desktop {
                    font-size: rem(20);
                }
            }
            .actions {
                .action {
                    font-size: mrem(16);
                    @include on-desktop {
                        font-size: rem(16);
                    }
                }
                .action-active {
                    font-weight: 600;
                }
            }
        }
    }
    .internship {
        display: grid;
        grid-template-columns: 1fr;
        width: 100%;
        margin-bottom: mrem(40);
        @include on-desktop {
            grid-template-columns: 1fr 1fr 1fr;
            gap: rem(50) rem(20);
            margin-bottom: rem(40);
        }
    }

    .load-more-btn {
        border-radius: 4px;
        padding: mrem(10) mrem(20);
        border: 1px solid #98a0a9;
        background-color: #fff;
        color: #98a0a9;
        font-size: mrem(18);
        font-weight: 400;
        cursor: pointer;

        @include on-desktop {
            padding: rem(10) rem(20);
            font-size: rem(18);
        }
        &:hover {
            font-size: mrem(18);
            color: #98a0a9 !important;
            @include on-desktop {
                font-size: rem(18);
            }
        }
        .load-more-icon {
            width: mrem(22);
            margin-right: mrem(6);
            @include on-desktop {
                width: rem(22);
                margin-right: rem(6);
            }
        }
    }
}
.text-center {
    text-align: center;
}
</style>
